module.exports = __webpack_public_path__ + "Gotham-Black.6aab5d67a7499a8de50d.woff";


//////////////////
// WEBPACK FOOTER
// /Users/vijay/projects/customers-app/src/assets/fonts/gotham/Gotham-Black.woff
// module id = ../../../../../src/assets/fonts/gotham/Gotham-Black.woff
// module chunks = styles